module.exports = __webpack_public_path__ + "static/24-53d6a8d65627952c9b65fb0d783de3d3.gif";